// Mock data for activities and events - SAT V4 Zone
import type { Activity } from '../../types';

export const mockActivities: Activity[] = [
  {
    id: 'act-001',
    name: 'Whole School Assembly',
    type: 'assembly',
    description: 'Weekly whole school assembly in the main hall',
    recurring: {
      dayOfWeek: 'wednesday',
      periodId: 'wednesday-p0',
    },
    isRecurring: true,
    duration: 30,
    affectedYearGroups: [7, 8, 9, 10, 11],
    yearGroups: [7, 8, 9, 10, 11],
    involvedTeachers: ['teacher-001', 'teacher-002'],
    involvedClasses: [],
    roomId: 'room-sc-2',
    status: 'scheduled',
  },
  {
    id: 'act-002',
    name: 'Year 7 Assembly',
    type: 'assembly',
    description: 'Year 7 specific assembly',
    recurring: {
      dayOfWeek: 'monday',
      periodId: 'monday-p0',
    },
    isRecurring: true,
    duration: 20,
    affectedYearGroups: [7],
    yearGroups: [7],
    involvedTeachers: ['teacher-010'],
    involvedClasses: [],
    roomId: 'room-sc-2',
    status: 'scheduled',
  },
  {
    id: 'act-003',
    name: 'Staff Meeting',
    type: 'meeting',
    description: 'Weekly staff meeting after school',
    recurring: {
      dayOfWeek: 'tuesday',
      periodId: 'tuesday-after',
    },
    isRecurring: true,
    duration: 60,
    affectedYearGroups: [],
    yearGroups: [],
    involvedTeachers: mockTeacherIds(),
    involvedClasses: [],
    roomId: 'room-lib',
    status: 'scheduled',
  },
  {
    id: 'act-004',
    name: 'Year 11 Mock Exams',
    type: 'exam',
    description: 'Year 11 GCSE mock examinations week',
    date: '2024-11-18',
    isRecurring: false,
    duration: 300,
    affectedYearGroups: [11],
    yearGroups: [11],
    involvedTeachers: [],
    involvedClasses: [],
    roomId: 'room-sc-2',
    status: 'scheduled',
  },
  {
    id: 'act-005',
    name: 'Sports Day',
    type: 'sports_day',
    description: 'Annual school sports day',
    date: '2025-07-10',
    isRecurring: false,
    duration: 360,
    affectedYearGroups: [7, 8, 9, 10, 11],
    yearGroups: [7, 8, 9, 10, 11],
    involvedTeachers: [],
    involvedClasses: [],
    roomId: 'room-sc-1',
    status: 'scheduled',
  },
  {
    id: 'act-006',
    name: 'Year 8 Science Trip',
    type: 'trip',
    description: 'Visit to Natural History Museum',
    date: '2025-03-15',
    isRecurring: false,
    duration: 360,
    affectedYearGroups: [8],
    yearGroups: [8],
    involvedTeachers: ['teacher-015', 'teacher-016', 'teacher-017'],
    involvedClasses: [],
    status: 'scheduled',
  },
  {
    id: 'act-007',
    name: 'Parents Evening - Year 10',
    type: 'event',
    description: 'Year 10 parents evening consultation',
    date: '2025-02-06',
    isRecurring: false,
    duration: 180,
    affectedYearGroups: [10],
    yearGroups: [10],
    involvedTeachers: [],
    involvedClasses: [],
    roomId: 'room-sc-2',
    status: 'scheduled',
  },
  {
    id: 'act-008',
    name: 'Drama Production',
    type: 'event',
    description: 'School drama production - Romeo and Juliet',
    date: '2025-03-20',
    isRecurring: false,
    duration: 180,
    affectedYearGroups: [9, 10, 11],
    yearGroups: [9, 10, 11],
    involvedTeachers: ['teacher-025'],
    involvedClasses: [],
    roomId: 'room-ac-4',
    status: 'scheduled',
  },
  {
    id: 'act-009',
    name: 'Year 11 Final Exams',
    type: 'exam',
    description: 'GCSE Final Examinations',
    date: '2025-05-12',
    isRecurring: false,
    duration: 600,
    affectedYearGroups: [11],
    yearGroups: [11],
    involvedTeachers: [],
    involvedClasses: [],
    status: 'scheduled',
  },
  {
    id: 'act-010',
    name: 'Open Evening',
    type: 'event',
    description: 'School open evening for prospective Year 7 parents',
    date: '2024-10-10',
    isRecurring: false,
    duration: 180,
    affectedYearGroups: [],
    yearGroups: [],
    involvedTeachers: [],
    involvedClasses: [],
    roomId: 'room-sc-2',
    status: 'completed',
  },
];

function mockTeacherIds(): string[] {
  return Array.from({ length: 75 }, (_, i) => `teacher-${String(i + 1).padStart(3, '0')}`);
}

export default mockActivities;
